<template>
    <svg
        width="90"
        height="90"
        viewBox="0 0 90 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            opacity="0.3"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M45 81C64.8823 81 81 64.8823 81 45C81 25.1177 64.8823 9 45 9C25.1177 9 9 25.1177 9 45C9 64.8823 25.1177 81 45 81ZM45 85C67.0914 85 85 67.0914 85 45C85 22.9086 67.0914 5 45 5C22.9086 5 5 22.9086 5 45C5 67.0914 22.9086 85 45 85Z"
            fill="#9AA1AE"
        />
        <path
            opacity="0.3"
            d="M65.6341 28.9897C67.2966 30.4445 67.4651 32.9715 66.0104 34.6341L42.3854 61.6341C41.6258 62.5021 40.5285 63.0001 39.3751 63.0001C38.2216 63.0001 37.1243 62.5021 36.3647 61.6341L23.9897 47.4912C22.535 45.8287 22.7035 43.3016 24.366 41.8469C26.0286 40.3922 28.5556 40.5606 30.0104 42.2232L39.3751 52.9257L59.9897 29.366C61.4445 27.7035 63.9715 27.535 65.6341 28.9897Z"
            fill="#51D475"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M58.4846 28.049C60.6667 25.5552 64.4573 25.3025 66.9511 27.4846C69.4449 29.6667 69.6976 33.4573 67.5155 35.9511L43.8905 62.9511C42.7512 64.2532 41.1053 65 39.3751 65C37.6449 65 35.999 64.2532 34.8596 62.9511L22.4846 48.8082C20.3025 46.3144 20.5552 42.5238 23.0491 40.3417C25.5429 38.1596 29.3335 38.4123 31.5155 40.9062L39.3751 49.8885L58.4846 28.049ZM64.3171 30.4949C63.4858 29.7675 62.2223 29.8518 61.4949 30.683L40.8802 54.2427C40.5005 54.6767 39.9518 54.9257 39.3751 54.9257C38.7984 54.9257 38.2497 54.6767 37.8699 54.2427L28.5052 43.5402C27.7779 42.7089 26.5143 42.6247 25.6831 43.352C24.8518 44.0794 24.7676 45.3429 25.4949 46.1742L37.8699 60.3171C38.2497 60.7511 38.7984 61 39.3751 61C39.9518 61 40.5005 60.7511 40.8802 60.3171L64.5052 33.3171C65.2326 32.4858 65.1484 31.2223 64.3171 30.4949Z"
            fill="#51D475"
        />
    </svg>
</template>
